import { getInitialState } from "./store/login";

export function returntypeof<RT>(expression: (...params: any[]) => RT): RT {
    return {} as RT;
}

// Checkls if there is a token or the user can login on fist start
export async function TokenCheck() {
    let token = localStorage.getItem("T") as string;
    if (token != null && token != undefined) {
        let username = localStorage.getItem("U") as string;
        let email = localStorage.getItem("E") as string;
        
        await fetch("/api/v1/token_check", {
            method: "GET",
            headers: {
                'SBPPortal-Ticket': token,
                "Semabench-Token" : token,
                "user": username,
                "email": email,
                'source': 'portal',
            }
        }).then(async res => {
            if (res.status == 401) {
                // Show the pop-up message
                let popup = document.getElementById("popup-logout");
                if (popup) {
                    popup.style.setProperty("display", "block");
                }

                // sessionStorage.clear();
                // Redirect to the login page after a delay
                setTimeout(() => {
                    localStorage.clear();
                    let popup2 = document.getElementById("popup-logout");
                    if (popup2) {
                        popup2.style.removeProperty("display");
                    }
                    getInitialState()
                    window.location.replace("../");
                }, 10000);
            }
        });
    }
}

